module.exports = __webpack_public_path__ + "static/media/icon-manage-class-mail.a27e8917.svg";